<template>
  <main id="mainCtrl">
    <dialog-doctor-moderation ref="doctorModerate" @openNext="moderateNext" @updated="onUpdatedEvent"/>
    <v-table
        id="mainTbl"
        request-uri="doctors/getList"
        pagesize="50"
        ref="table"
    >
      <template v-slot:header>
        <v-tr>
          <v-th name="city" width="55">Город</v-th>
          <v-th name="fio" sort="nameFamily, nameFirst, nameFathers" width="200">
            Фамилия Имя Отчество
          </v-th>
          <v-th name="rating" sort="rating" width="40" ><i class="fas fa-star-half-alt"></i></v-th>
          <v-th name="moderationNeeded" width="30"  tooltip="Требуется модерация"> М </v-th>
          <v-th name="clinicName" minwidth="150">
            Клиника
          </v-th>
          <v-th name="price" tooltip="Стоимость консультации" width="50">
            Прием
          </v-th>
          <v-th name="experience" tooltip="Стаж" width="35" >
            Ст
          </v-th>
          <v-th name="speciality" sort="specialities_ids" minwidth="150">
            Специализации
          </v-th>
          <v-th name="url" sort="url" minwidth="100">
            URL
          </v-th>
          <v-th name="link_created_at" width="86">
            Создан
          </v-th>
          <v-th name="createdBy_id" sort="createdBy_id"  width="40">
            Созд
          </v-th>
          <v-th name="moderation_created_at" sort="moderation_created_at"  width="86">
            Измен
          </v-th>
        </v-tr>
        <v-tr>
          <v-th name="city" v-slot="{filter}">
            <v-select
                v-model="filter.value"
                :options='[
                                {
                                    text: "\u00a0",
                                    value: ""
                                },
                                ...cityOptions
                            ]'
            ></v-select>
          </v-th>
          <v-th name="fio" :debounce="true" v-slot="{filter}">
            <v-input v-model="filter.value"/>
          </v-th>
          <v-th name="rating" v-slot="{filter}">
            <v-select
                v-model="filter.value"
                :options="[
                                {
                                    text: '\u00a0',
                                    value: ''
                                },
                                {
                                    value: '-',
                                    text: '- нет'
                                },
                                {
                                    value: '1',
                                    text: '1 ★☆☆☆☆'
                                },
                                {
                                    value: '2',
                                    text: '2 ★★☆☆☆'
                                },
                                {
                                    value: '3',
                                    text: '3 ★★★☆☆'
                                },
                                {
                                    value: '4',
                                    text: '4 ★★★★☆'
                                },
                                {
                                    value: '5',
                                    text: '5 ★★★★★'
                                }
                            ]"
            ></v-select>
          </v-th>
          <v-th name="moderationNeeded" v-slot="{filter}">
            <v-select v-model="filter.value"
                      :options='[
                                  { text: "\u00a0", value: "" },
                                  { text: "⊞ Новый", value: "NEW" },
                                  { text: "👁 Измененные", value: "CHANGED"},
                                  { text: "👁 На модерации (новые и измененные)", value: "MOD_NEEDED"},
                                  { text: "✔ Не требуется модерацию", value: "MOD_NOT_NEEDED"},
                                ]'>
              <template v-slot:option="option">
                <div v-html="option.text"/>
              </template>
            </v-select>
          </v-th>
          <v-th name="clinicName" :debounce="true" v-slot="{filter}">
            <v-input type="search" v-model="filter.value" style="flex: 1 1 0; min-width: auto !important;"/>
          </v-th>
          <v-th name="price" v-slot="{filter}">
            <v-select v-model="filter.value"
                      :options="[
                                  { text: '\u00a0', value: '' },
                                  { text: 'платно', value: '>0' },
                                  { text: 'бесплатно', value: '=0'},
                                  { text: 'неизвестно', value: '=?'},
                                ]"/>
          </v-th>
          <v-th name="experience" v-slot="{filter}">
            <v-input type="search" v-model="filter.value"/>
          </v-th>
          <v-th name="speciality" v-slot="{filter}">
            <v-select
                v-model="filter.value"
                :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                ...specialityOptions
                            ]'
            />
          </v-th>
          <v-th name="url" v-slot="{filter}">
            <v-input type="search" v-model="filter.value"/>
          </v-th>
          <v-th name="link_created_at" v-slot="{filter}">
            <date-piker v-model="filter.value"/>
          </v-th>
          <v-th name="createdBy_id" v-slot="{filter}">
            <v-select
                v-model="filter.value"
                :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "-",
                                    text: "— не задано —"
                                },
                                ...managerOptions.map(item => {
                                    return {
                                        value: item.id,
                                        text: item.fioInitials + " - " + item.fio
                                    };
                                })
                            ]'
            />
          </v-th>
          <v-th name="moderation_created_at" v-slot="{filter}">
            <date-piker v-model="filter.value"/>
          </v-th>
        </v-tr>
      </template>

      <template v-slot:row="{ item, index }">
        <v-tr @click="(row, event) => handleRowClick(event, row, item)" :class="{lightWarning: item.moderationIsNew}">
          <v-td name="city" align="center">
            <div v-for="source in item.sources">
              <div v-html="source.cityNameShort" :class="{warning: source.isModerationSource}" v-tooltip="{content: source.cityName}"/>
            </div>
          </v-td>
          <v-td name="fio">
            <div class="text-ellipsis-hover">
              <b>{{item.nameFamily}}</b> {{item.nameFirst}} {{item.nameFathers}}
            </div>
          </v-td>
          <v-td name="rating" highlight="*" align="center">
            <div v-if="item.rating == null">&mdash;</div>
            <div v-else v-tooltip="{content:innerTooltip(item)}">{{ (Math.round(item.rating * 5 * 10) / 10).toFixed(1) }}</div>
          </v-td>
          <v-td name="moderationNeeded" align="center">
            <div v-for="source in item.sources">
              <div :class="{warning: source.isModerationSource, lightWarning: item.moderationIsNew}" v-tooltip="{content: source.cityName}">
                <span v-if="source.isModerationSource"><i class="fa fa-eye"/></span>
                <span v-else-if="item.moderationIsNew" style="color:red"><i class="far fa-plus-square"/></span>
                <span v-else><i class="fa fa-check"></i></span>
              </div>
            </div>
          </v-td>
          <v-td name="clinicName">
            <div v-for="source in item.sources">
              <div :class="{warning: source.isModerationSource}"
                   :style="{'text-decoration' : (source.deleted_at === null ? 'inherit' : 'line-through')}"
                   v-tooltip="{content: source.cityName}" class="text-ellipsis"
              >
                <i class="fa fa-book" v-if="source.sourceType === 'clinic'"
                   :class="[source.hasAbonSubscription ? 'text-success' : 'text-danger']"
                   v-tooltip="{content: source.hasAbonSubscription ? 'Есть запись' : 'Нет записи'}"/>
                {{ source.name }}
              </div>
            </div>
          </v-td>
          <v-td name="price" align="right">
            <div v-for="source in item.sources" :class="{warning: !!source.moderationNeeded}">
              <div v-if="source.sourceType === 'clinic'">
                <template v-if="source.price === '' || source.price === null">&mdash;</template>
                <template v-if="source.price === 0">беспл.</template>
                <template v-if="source.price > 0">{{source.price}}</template>
              </div>
              <div v-else>&mdash;</div>
            </div>
          </v-td>
          <v-td name="experience" align="center">{{item.experience}}</v-td>
          <v-td name="speciality">{{item.specialitiesAsText}}</v-td>
          <v-td name="url">
            <a class="text-ellipsis"
               :href="$parent.frontendUrl+'/'+item.bestCityCharId+'/doctor/'+item.url"
               v-tooltip="{content: $parent.frontendUrl+'<br/>/'+item.bestCityCharId+'/doctor/'+item.url}"
               target='_blank'
               @click.stop.prevent="openHref($parent.frontendUrl+'/'+item.bestCityCharId+'/doctor/'+item.url)">
              /{{item.url}}
            </a>
          </v-td>
          <v-td name="link_created_at" :highlight="createdAtHighlight" align="center">
            <div v-for="source in item.sources">
              <span v-if="source.created_at" :style="{'text-decoration' : (source.deleted_at === null ? 'inherit' : 'line-through')}">{{source.created_at | formatDate}}</span>
              <span v-else>&mdash;</span>
            </div>
          </v-td>
          <v-td name="createdBy_id" align="center">
            <div v-for="source in item.sources">
              <span v-if="source.createdBy"
                    :style="{'text-decoration' : (source.deleted_at === null ? 'inherit' : 'line-through')}"
                    v-tooltip="{content: source.createdBy.fio}"
              >{{source.createdBy.fioInitials}}</span>
              <span v-else>&mdash;</span>
            </div>
          </v-td>
          <v-td name="moderation_created_at" :highlight="updatedAtHighlight" align="center">
            <div v-for="source in item.sources">
              <span v-if="source.changed_at">{{source.changed_at | formatDate}}</span>
              <span v-else>&mdash;</span>
            </div>
          </v-td>
        </v-tr>

      </template>
    </v-table>
  </main>
</template>
<script>
import DialogDoctorModeration from '@dialogs/admin/doctorModeration/Dialog'
import moment from "moment/moment";
import 'moment/locale/ru';
export default {
  components: { DialogDoctorModeration },
  props: {
    cityOptions: {
      type: Array,
      required: true
    },
    managerOptions: {
      type: Array,
      required: true
    },
    specialityOptions: {
      type: Array,
      required: true
    },
  },

  data: function () {return {}},
  created: function () {
    this.$store.dispatch('dictionary/fetchAllOptions');
    this.$store.dispatch('dictionary/fetchSpecialityOptions');
  },
  methods: {
    moderateNext (doctorId) {
      setTimeout(async () => {
        let previousClinicId = doctorId;
        let row, index;

        for (const i in this.$refs.table.rows) {
          index = parseInt(i);
          row = this.$refs.table.rows[index];

          if (row.id === previousClinicId && this.$refs.table.rows[index + 1] && this.$refs.table.rows[index + 1].id) {
            await this.axios.get('/admin/moderation/doctors/' + this.$refs.table.rows[index + 1].id + '/isOpened')
                .then(data => {
                  if (data.data.success) {
                    const nextRow = document.querySelectorAll('#mainTbl table tbody tr.table-row')[index + 1];
                    if (nextRow) {
                      nextRow.click();
                    }
                    this.$refs.table.update();
                  } else {
                    previousClinicId = this.$refs.table.rows[index + 1].id;
                  }
                });
          }
        }
      }, 1000);
    },
    openHref(href) {
      window.open(href)
    },
    onUpdatedEvent (){
      this.$refs.table.update();
    },
    handleRowClick: function (event, row, item) {
      row.startLoadingAnimation();
      //
      this.moderateDoctor(item.id, event, row);
    },
    moderateDoctor: function (id, e, row)  {
      this.$refs.doctorModerate
          .showModal(id)
          .then(() => row.stopLoadingAnimation())
          .catch(() => row.stopLoadingAnimation());
    },
    innerTooltip(item) {
      return `<div class="tooltip-content">
                    <table>
                        <tr><td width="85">Рейтинг:</td><td width="50">` + (Math.round(item.rating * 5 * 10) / 10).toFixed(1) + `</td></tr>
                        <tr><td>Отзывы:</td><td>` + item.ratingCommentCount + `</td></tr>
                        <tr><td>Внутренний:</td><td>` + item.ratingInternal + `</td></tr>
                    </table>
            </div>`;
    },

  },
  computed: {
    createdAtHighlight() {
      if (!this.$refs || !this.$refs.table.filter) {
        return '*';
      }
      if(this.$refs.table.filter.created_at){
        return moment(this.$refs.table.filter.created_at, "DD.MM.YYYY").locale('ru')
            .format('DD MMM YYYY')
            .replace(/(\d{2}) (\W{3})(\W{0,2}).\s(\d{4})/g, "$1 $2 $4" )
      }
      return '*';
    },
    updatedAtHighlight() {
      if (!this.$refs || !this.$refs.table.filter) {
        return '*';
      }
      if(this.$refs.table.filter.updated_at){
        return moment(this.$refs.table.filter.updated_at, "DD.MM.YYYY").locale('ru')
            .format('DD MMM YYYY')
            .replace(/(\d{2}) (\W{3})(\W{0,2}).\s(\d{4})/g, "$1 $2 $4" )
      }
      return '*';
    },
  }

}
</script>
<style scoped>
.warning {
    border-right: 1px solid rgba(229, 230, 0, 0.22) !important;
}
.lightWarning {
    border-right: 1px solid rgba(229, 230, 0, 0.22) !important;
}
tr.warning td {
    background-color: rgba(255, 255, 0, 0.22) !important;
}
tr.lightWarning td {
    background-color: rgba(255, 255, 0, .15) !important;
}
</style>
